import { DialogBody } from '@/shared/components';
import { PROPERTY_DOCUMENT_KIND_LABELS, type PropertyDocumentKind } from '@/shared/api';
import { RECLASSIFY_KIND_OPTIONS } from './akteKindLabels';

interface Props {
  /** Prefix für stabile label/input-Ids (Einzel- vs. Bulk-Dialog). */
  idPrefix: string;
  kind: PropertyDocumentKind;
  onKindChange: (kind: PropertyDocumentKind) => void;
  /** Beleg-Datum-Feld einblenden (datums-pflichtiges Ziel-Kind ohne vorhandenes Datum). */
  needsDate: boolean;
  issuedOn: string;
  onIssuedOnChange: (value: string) => void;
  dateError: boolean;
  /** Optionaler Zusatz am Datums-Label (z. B. Bulk: „für Dateien ohne eigenes Datum"). */
  dateHint?: string;
}

/** Kind-Auswahl + bedingtes Beleg-Datum-Feld — geteilt von Einzel- und Bulk-Reclassify. */
export function ReclassifyFields({
  idPrefix,
  kind,
  onKindChange,
  needsDate,
  issuedOn,
  onIssuedOnChange,
  dateError,
  dateHint,
}: Props) {
  return (
    <DialogBody className="space-y-4">
      <div>
        <label
          htmlFor={`${idPrefix}-kind`}
          className="text-ink-soft mb-1 block text-xs font-medium uppercase tracking-wider"
        >
          Kategorie
        </label>
        <select
          id={`${idPrefix}-kind`}
          value={kind}
          onChange={(e) => onKindChange(e.target.value as PropertyDocumentKind)}
          className="border-line bg-card text-ink focus:border-sealwax w-full rounded-md border px-3 py-2 text-sm outline-none"
        >
          {RECLASSIFY_KIND_OPTIONS.map((k) => (
            <option key={k} value={k}>
              {PROPERTY_DOCUMENT_KIND_LABELS[k]}
            </option>
          ))}
        </select>
      </div>
      {needsDate && (
        <div>
          <label
            htmlFor={`${idPrefix}-date`}
            className="text-ink-soft mb-1 block text-xs font-medium uppercase tracking-wider"
          >
            Beleg-Datum *{dateHint && <span className="normal-case"> ({dateHint})</span>}
          </label>
          <input
            id={`${idPrefix}-date`}
            type="date"
            value={issuedOn}
            onChange={(e) => onIssuedOnChange(e.target.value)}
            style={{ colorScheme: 'light' }}
            className={
              'w-full rounded-md border px-3 py-2 text-sm outline-none ' +
              (dateError ? 'border-sealwax' : 'border-line focus:border-sealwax')
            }
          />
          {dateError && (
            <p className="text-sealwax mt-1 text-xs" role="alert">
              Für diese Kategorie ist ein Beleg-Datum erforderlich.
            </p>
          )}
        </div>
      )}
    </DialogBody>
  );
}
